import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'userId',
      type: 'input',
      label: '业务员ID',
      placeholder: '请输入业务员Id'
    },
    {
      field: 'corPid',
      type: 'select',
      label: '主体',
      placeholder: '请选择主体',
      filterable: true,
      clearable: true,
      options: []
    },
    {
      field: 'userName',
      type: 'input',
      label: '账号名称',
      placeholder: '请输入账号名称'
    },
    {
      field: 'usedBy',
      type: 'select',
      label: '使用人',
      filterable: true,
      clearable: true,
      placeholder: '请选择使用人'
    },
    {
      field: 'nickName',
      type: 'input',
      label: '客户昵称',
      placeholder: '请输入客户昵称'
    },
    {
      field: 'timeSlot',
      type: 'datepicker',
      label: '回复日期',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    },
    // {
    //   field: 'replyDual',
    //   type: 'select',
    //   label: '回复时长',
    //   placeholder: '请选择业务员回复时长',
    //   options: [
    //     { title: '尚未回复', value: 0 },
    //     { title: '大于60分钟', value: 1 },
    //     { title: '大于6小时', value: 2 },
    //     { title: '大于1天', value: 3 }
    //   ],
    //   clearable: true
    // },
    {
      field: 'showNew',
      type: 'switch',
      label: '仅列出新客户',
      activeValue: 1,
      inActiveValue: 0
    }
  ]
}
